<template>
    <pg-page title="Private Gym - Lidmaatschap Status"
             header="Bevestiging van de betaling"
             header_tag="h2"
             id="lid-worden"
             :footer="false"
    >

        <div class="mx-auto mt-4">
            <form novalidate>
                <div class="row g-3 justify-content-center">
                    <div class="col-sm-6 text-center">
                        <div class="card mb-2 rounded-3 shadow-sm">
                            <div class="card-header py-3">
                                <h4 class="my-0 fw-normal" v-if="status === ''">
                                    Even geduld{{ dots }}
                                </h4>
                                <h4 class="my-0 fw-normal" v-else-if="status === 'paid' && !attached">
                                    Je kunt nu inloggen 🎉
                                </h4>
                                <h4 class="my-0 fw-normal" v-else-if="status === 'paid' && attached">
                                    Je nieuwe abonnement is gekoppeld 🎉
                                </h4>
                                <h4 class="my-0 fw-normal" v-else-if="status === 'expired'">
                                    Verlopen
                                </h4>
                                <h4 class="my-0 fw-normal" v-else-if="status === 'failed'">
                                    Mislukt
                                </h4>
                                <h4 class="my-0 fw-normal" v-else-if="status === 'canceled'">
                                    Geannuleerd
                                </h4>
                                <h4 class="my-0 fw-normal" v-else>
                                    Onbekende status. Neem even contact met ons op. Er lijkt iets mis te gaan
                                </h4>
                            </div>
                        </div>
                        <div class="card p-4 text-dark bg-warning mb-2 rounded-3 shadow-sm" v-if="isPaid && !attached">
                            We dubbelchecken nog even handmatig je registratie voordat je kunt reserveren. Om er zeker van te zijn dat je al een keer een rondleiding hebt gehad :-)
                        </div>
                        <div class="card mb-2 rounded-3 shadow-sm" v-if="isPaid">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-6">
                                        <a href="https://apps.apple.com/us/app/private-gym-clients/id1615723985">
                                            <img class="w-100" src="/images/app/ios-download.png" alt="Download de iOS app">
                                        </a>
                                    </div>
                                    <div class="col-6">
                                        <a href="https://app.private-gym.nl/">
                                            <img class="w-100" src="/images/app/playstore-download.png" alt="Download de Playstore app">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card mb-2 rounded-3 shadow-sm">
                            <div class="card-body my-3">
                                <div v-bind:class="{
                                    'circle-loader': true,
                                    'load-complete': statusIsSet,
                                    'checkmark': isPaid,
                                    'failmark': !isPaid,
                                }">
                                    <div class="checkmark draw" v-show="statusIsSet"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

    </pg-page>
</template>

<script>

import PgPage from "../../../Components/PgPage";
import ContactModal from "../../../Components/Contact/ContactModal";
import axios from "axios";

export default {
    components: {ContactModal, PgPage},

    props: {
        attached: {default: false}, // we use this one for a slightly different version of the success page
    },

    mixins: [],

    data: function () {
        return {
            loading: false,
            subscriptionStatusSet: false,
            checkInterval: null,
            status: '',
            dots: '.',
        };
    },

    computed: {
        subscriptionId() {
            return this.$page['props']['subscriptionId'];
        },
        statusIsSet() {
            return this.status.length > 0;
        },
        isPaid() {
            return this.status === 'paid';
        },
    },

    created() {
        //
    },

    mounted() {
        console.log(process.env.MIX_API_URL);

        setInterval(() => {
            if (this.dots === '...') {
                this.dots = '';
            }
            this.dots += '.';
        }, 500);

        this.checkInterval = setInterval(() => {
            this.checkStatus();
        }, 2000);
    },

    methods: {
        checkStatus() {
            const vm = this;
            this.loading = true;

            window.axios.get(process.env.MIX_API_URL + '/api/v1/subscriptions/' + this.subscriptionId + '/first-payment', {})
                .then(function (response) {
                    if(typeof response.data.data.status !== 'undefined' && response.data.data.status !== null) {
                        vm.subscriptionStatusSet = true;
                        vm.status = response.data.data.status;
                    }
                })
                .catch(function (error) {
                    console.log('catch', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },

    watch: {
        subscriptionStatusSet(value) {
            if(value) {
                clearInterval(this.checkInterval);
            }
        }
    }
};
</script>
<style lang="scss">
#lid-worden label {
    font-weight: bold;
    color: red;
}
</style>
